import script from "./MarkdownArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkdownArticle.vue?vue&type=script&setup=true&lang=ts"

import "./MarkdownArticle.vue?vue&type=style&index=0&id=d006e07e&lang=css"

const __exports__ = script;

export default __exports__